import React, { useState } from "react";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from "@react-google-maps/api";
import MarkerClusterer from "@googlemaps/markerclustererplus";
import { Link } from "components/ui";

const containerStyle = {
	width: "100%",
	height: "600px",
	borderRadius: "12px",
};

function AbcoMap({ data }) {
	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: "AIzaSyDd7s8LXb4MVE5jGztgCtlnbzQ0ZY8aE9Q",
	});

	const [map, setMap] = useState(null);
	const [markerClusterer, setMarkerClusterer] = useState(null);
	const [selectedMarker, setSelectedMarker] = useState(null);

	const onLoad = React.useCallback(
		function callback(map) {
			const bounds = new window.google.maps.LatLngBounds();
			data.forEach((item) => {
				bounds.extend({
					lat: item.latitude,
					lng: item.longitude,
				});
			});

			map.fitBounds(bounds);
			setMap(map);

			// Create marker clusterer
			const markerCluster = new MarkerClusterer(map, [], {
				imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
			});
			setMarkerClusterer(markerCluster);
		},
		[data],
	);

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const markerData = data.map((item) => ({
		id: item.id,
		position: {
			lat: item.latitude,
			lng: item.longitude,
		},
		data: item,
	}));

	React.useEffect(() => {
		if (markerClusterer) {
			const markers = markerData.map((marker) => {
				const newMarker = new window.google.maps.Marker({
					position: marker.position,
				});
				newMarker.addListener("click", () => {
					setSelectedMarker(marker);
				});
				return newMarker;
			});
			markerClusterer.clearMarkers();
			markerClusterer.addMarkers(markers);
		}
	}, [markerData, markerClusterer]);

	const handleCloseClick = () => {
		setSelectedMarker(null);
	};

	return isLoaded ? (
		<GoogleMap mapContainerStyle={containerStyle} onLoad={onLoad} onUnmount={onUnmount}>
			{selectedMarker && (
				<InfoWindow position={selectedMarker.position} onCloseClick={handleCloseClick}>
					<div>
						<h2>{selectedMarker.data.name}</h2>
						<div>{selectedMarker.data.addressLine1}</div>
						<div>{selectedMarker.data.addressLine2}</div>
						<Link href={"/sites/" + selectedMarker.data.id}>View</Link>
					</div>
				</InfoWindow>
			)}
		</GoogleMap>
	) : (
		<></>
	);
}

export default React.memo(AbcoMap);
